import React from "react";
import Tools from "./Tools";

const Item = props => {
  const { kind, divClasses, connectDragSource, Component, id, meta } = props;
  if (kind === "block" || kind === "table") {
    return (
      <div className={divClasses}>
        <Tools connectDragSource={connectDragSource} id={id} meta={meta} />
        <Component {...props} />
      </div>
    );
  }

  return connectDragSource(
    <div className={divClasses}>
      <Tools connectDragSource={connectDragSource} id={id} meta={meta} />
      <Component {...props} />
    </div>
  );
};

export default Item;
